import Interms from "./IncotermsContainer";
export default Interms;
